
        import { G as Group, B as BoxGeometry, d as Mesh, M as MeshStandardMaterial, m as MeshPhysicalMaterial, b as Color } from "./assets/scene-CqtYl5hY.js";
        import { sliderValues, colorValues } from "./assets/UI-DDGmle1R.js";
        import { f_guillotine } from "./assets/RoundedBoxGeometry-Coz6wR2R.js";

        (function () {
            const ACCENT = '#b8c94a';
            const MUTED = '#7a7d6a';
            const BORDER = '#2e3028';
            const SURFACE2 = '#1d1f1a';

            const activeSides = { left: false, right: false, front: false, back: false };
            const guillotineMeshes = {};

            function updateSubOptions() {
                const anyActive = Object.values(activeSides).some(Boolean);
                const sub = document.getElementById('guillotineSubOptions');
                if (sub) sub.style.display = anyActive ? '' : 'none';

                document.querySelectorAll('.guillotine-control').forEach(el => {
                    el.classList.toggle('disabled-control', !anyActive);
                });
            }

            function buildGlassRoof() {
                const scene = window.__pergolaScene;
                if (!scene) return;
                const bioGroup = scene.getObjectByName("bioGroup");
                const mainGroup = scene.getObjectByName("mainGroup");
                const tentoGroup = scene.getObjectByName("tentoGroup");
                const targetParent = mainGroup || tentoGroup || bioGroup;

                const typeRadio = document.querySelector('input[name="pergolaType"]:checked');
                const isGlassRoof = typeRadio && typeRadio.value === 'glass_roof_pergko';

                // Clean removal of ALL blades, louvers, and fabric beneath
                if (bioGroup) {
                    bioGroup.traverse(c => {
                        if (c.name === 'persides' || c.name === 'Tmesh' || c.name === 'blade' || c.name === 'louver' || (c.parent && c.parent.name === 'persides')) {
                            c.visible = !isGlassRoof;
                        }
                    });
                    const oldRoof = bioGroup.getObjectByName("glassRoofGroup");
                    if (oldRoof) {
                        bioGroup.remove(oldRoof);
                        oldRoof.traverse(c => {
                            if (c.geometry) c.geometry.dispose();
                            if (c.material) {
                                if (Array.isArray(c.material)) c.material.forEach(m => m.dispose());
                                else c.material.dispose();
                            }
                        });
                    }
                }
                if (mainGroup) {
                    mainGroup.traverse(c => {
                        if (c.name === 'fabrGroup' || c.name === 'stirigmataGroup' || c.name === 'containerGroup') {
                            if (isGlassRoof) c.visible = false;
                        }
                    });
                    const oldRoof = mainGroup.getObjectByName("glassRoofGroup");
                    if (oldRoof) {
                        mainGroup.remove(oldRoof);
                        oldRoof.traverse(c => {
                            if (c.geometry) c.geometry.dispose();
                            if (c.material) {
                                if (Array.isArray(c.material)) c.material.forEach(m => m.dispose());
                                else c.material.dispose();
                            }
                        });
                    }
                }
                if (tentoGroup) {
                    tentoGroup.traverse(c => {
                        if (c.name === 'fabrGroup' || c.name === 'stirigmataGroup' || c.name === 'containerGroup') {
                            if (isGlassRoof) c.visible = false;
                        }
                    });
                }

                if (!isGlassRoof || !targetParent) return;

                const widthX = sliderValues.widthX || 40;
                const widthZ = sliderValues.widthZ || 30;
                const height = sliderValues.columnHeight || 25;
                const baseColor = colorValues.baseColor ? colorValues.baseColor.color : (colorValues.tentoAluminium ? colorValues.tentoAluminium.color : "#293133");

                const roofGroup = new Group();
                roofGroup.name = "glassRoofGroup";

                const frameMat = new MeshStandardMaterial({
                    color: new Color(baseColor),
                    roughness: 0.25,
                    metalness: 0.5
                });

                const glassMat = new MeshPhysicalMaterial({
                    color: new Color(0xffffff),
                    transmission: 0.95,
                    opacity: 0.88,
                    transparent: true,
                    roughness: 0.05,
                    metalness: 0.1,
                    ior: 1.5,
                    reflectivity: 0.9
                });

                // 1. Fabric-Pergola Sloping Roof Geometry
                // Slope ratio matches fabric pergola (10% to 15% pitch based on depth)
                const slopeRatio = (10 + (Math.max(20, Math.min(70, widthZ)) - 20) / 50 * 5) / 100;
                const slopeAngle = Math.atan(slopeRatio);

                // Front gutter is at z = widthZ / 2 + 0.5; Wall front face is at z = -widthZ / 2 + 1.60
                const zRear = -widthZ / 2 + 1.66;
                const zFront = widthZ / 2 + 0.45;
                const spanZ = zFront - zRear;
                const zCenter = (zFront + zRear) / 2;
                const distFromFront = (widthZ / 2 + 0.5) - zCenter;
                const yCenter = height + 0.5 + Math.tan(slopeAngle) * distFromFront + 0.42;
                const slopeLength = spanZ / Math.cos(slopeAngle);

                // 2. Maximum width per section is 150cm (15.0 in internal units)
                const maxSectionWidth = 15.0;
                const sectionCount = Math.max(1, Math.ceil(widthX / maxSectionWidth));
                const stepX = (widthX - 1.8) / sectionCount;
                const paneW = stepX - 0.28;

                // 3. Telescoping Multi-Tier Glass Panes per bay (sloping from rear down to front)
                const panelCount = 3;
                const usableSlopeLength = slopeLength - 0.06;
                const paneD = usableSlopeLength / panelCount;
                const sRear = -usableSlopeLength / 2 + paneD / 2;

                const slidingPanesList = [];

                // Guide rafters dividing each glass section
                for (let r = 0; r <= sectionCount; r++) {
                    const rx = -widthX / 2 + 0.9 + r * stepX;
                    const rafterGeo = new BoxGeometry(0.14, 0.24, slopeLength);
                    const rafterMesh = new Mesh(rafterGeo, frameMat);
                    rafterMesh.castShadow = true;
                    rafterMesh.receiveShadow = true;
                    rafterMesh.rotation.x = slopeAngle;
                    rafterMesh.position.set(rx, yCenter + 0.12, zCenter);
                    roofGroup.add(rafterMesh);
                }

                for (let i = 0; i < sectionCount; i++) {
                    const rx = -widthX / 2 + 0.9 + i * stepX + stepX / 2;

                    // Panel 0: Fixed rear top pane (closest to wall, never penetrates wall)
                    const fixedGroup = new Group();
                    fixedGroup.name = "fixedRoofPane_" + i;

                    const fixedGlassGeo = new BoxGeometry(paneW, 0.08, paneD);
                    const fixedGlassMesh = new Mesh(fixedGlassGeo, glassMat);
                    fixedGlassMesh.castShadow = true;
                    fixedGlassMesh.receiveShadow = true;
                    fixedGroup.add(fixedGlassMesh);

                    const fixedSashRearGeo = new BoxGeometry(paneW, 0.16, 0.12);
                    const fixedSashRear = new Mesh(fixedSashRearGeo, frameMat);
                    fixedSashRear.position.set(0, 0, -paneD / 2 + 0.06);
                    fixedGroup.add(fixedSashRear);

                    const fixedSashFrontGeo = new BoxGeometry(paneW, 0.16, 0.12);
                    const fixedSashFront = new Mesh(fixedSashFrontGeo, frameMat);
                    fixedSashFront.position.set(0, 0, paneD / 2 - 0.06);
                    fixedGroup.add(fixedSashFront);

                    const fixedY = yCenter - sRear * Math.sin(slopeAngle);
                    const fixedZ = zCenter + sRear * Math.cos(slopeAngle);
                    fixedGroup.position.set(rx, fixedY, fixedZ);
                    fixedGroup.rotation.x = slopeAngle;
                    roofGroup.add(fixedGroup);

                    // Sliding Panels (p = 1 to panelCount - 1)
                    for (let p = 1; p < panelCount; p++) {
                        const slidingGroup = new Group();
                        slidingGroup.name = "slidingRoofPane_" + i + "_" + p;

                        const glassGeo = new BoxGeometry(paneW, 0.08, paneD);
                        const glassMesh = new Mesh(glassGeo, glassMat);
                        glassMesh.castShadow = true;
                        glassMesh.receiveShadow = true;
                        slidingGroup.add(glassMesh);

                        const sashRearGeo = new BoxGeometry(paneW, 0.16, 0.12);
                        const sashRear = new Mesh(sashRearGeo, frameMat);
                        sashRear.position.set(0, 0, -paneD / 2 + 0.06);
                        slidingGroup.add(sashRear);

                        const sashFrontGeo = new BoxGeometry(paneW, 0.16, 0.12);
                        const sashFront = new Mesh(sashFrontGeo, frameMat);
                        sashFront.position.set(0, 0, paneD / 2 - 0.06);
                        slidingGroup.add(sashFront);

                        slidingGroup.rotation.x = slopeAngle;
                        roofGroup.add(slidingGroup);

                        slidingPanesList.push({
                            group: slidingGroup,
                            rx: rx,
                            p: p,
                            paneD: paneD,
                            sRear: sRear,
                            slopeAngle: slopeAngle,
                            yCenter: yCenter,
                            zCenter: zCenter
                        });
                    }
                }

                roofGroup.userData.updatePosition = function (pos) {
                    const ratio = Math.max(0, Math.min(100, pos)) / 100;
                    slidingPanesList.forEach(item => {
                        const sCurrent = item.sRear + item.p * item.paneD * ratio;
                        const py = item.yCenter + item.p * 0.10 - sCurrent * Math.sin(item.slopeAngle);
                        const pz = item.zCenter + sCurrent * Math.cos(item.slopeAngle);
                        item.group.position.set(item.rx, py, pz);
                    });
                };

                const initialRoofPos = (typeof sliderValues.glassRoofPosition !== 'undefined') ? sliderValues.glassRoofPosition : 100;
                roofGroup.userData.updatePosition(initialRoofPos);

                targetParent.add(roofGroup);
            }

            function syncGuillotineSide3D(side, isActive) {
                const scene = window.__pergolaScene;
                if (!scene) return;
                const bioGroup = scene.getObjectByName("bioGroup");
                const mainGroup = scene.getObjectByName("mainGroup");
                const targetParent = bioGroup || mainGroup;
                if (!targetParent) return;

                if (guillotineMeshes[side]) {
                    if (guillotineMeshes[side].parent) {
                        guillotineMeshes[side].parent.remove(guillotineMeshes[side]);
                    } else {
                        targetParent.remove(guillotineMeshes[side]);
                    }
                    if (guillotineMeshes[side].userData && guillotineMeshes[side].userData.cleanup) {
                        guillotineMeshes[side].userData.cleanup();
                    }
                    delete guillotineMeshes[side];
                }

                if (!isActive) return;

                const widthX = sliderValues.widthX || 40;
                const widthZ = sliderValues.widthZ || 30;
                const height = sliderValues.columnHeight || 25;
                const clearH = height - 1.4;

                let span = 0;
                let posX = 0;
                let posY = clearH / 2 + 0.1;
                let posZ = 0;
                let rotY = 0;

                if (side === "left") {
                    span = widthZ - 3;
                    posX = -widthX / 2 + 0.5;
                    posZ = 0;
                    rotY = -Math.PI / 2;
                } else if (side === "right") {
                    span = widthZ - 3;
                    posX = widthX / 2 - 0.5;
                    posZ = 0;
                    rotY = -Math.PI / 2;
                } else if (side === "back") {
                    span = widthX - 3;
                    posX = 0;
                    posZ = -widthZ / 2 + 0.5;
                    rotY = 0;
                } else if (side === "front") {
                    span = widthX - 3;
                    posX = 0;
                    posZ = widthZ / 2 - 0.5;
                    rotY = 0;
                }

                const mesh = f_guillotine(span, clearH);
                mesh.position.set(posX, posY, posZ);
                mesh.rotation.y = rotY;
                mesh.name = "guillotineGroup_" + side;

                targetParent.add(mesh);
                guillotineMeshes[side] = mesh;
            }

            function refreshAllGuillotines() {
                Object.keys(activeSides).forEach(side => {
                    if (activeSides[side]) {
                        syncGuillotineSide3D(side, true);
                    }
                });
            }

            document.querySelectorAll('.giyotin-opt-btn').forEach(btn => {
                btn.addEventListener('click', function () {
                    const group = this.dataset.group;
                    const val = this.dataset.val;
                    document.querySelectorAll('.giyotin-opt-btn[data-group="' + group + '"]').forEach(b => {
                        b.classList.remove('active');
                        b.removeAttribute('style');
                    });
                    this.classList.add('active');

                    if (group === 'panel_count') {
                        sliderValues.guillotinePanelCount = parseInt(val, 10);
                        document.dispatchEvent(new CustomEvent('sliderValuesChanged', {
                            detail: { slider: 'guillotinePosition', value: sliderValues.guillotinePosition || 100 }
                        }));
                    }
                    refreshAllGuillotines();
                });
            });

            function onPergolaTypeChange(type) {
                document.querySelectorAll('.bio-settings').forEach(el => {
                    el.style.display = type === 'bio_pergko' ? '' : 'none';
                });
                document.querySelectorAll('.retractable-settings').forEach(el => {
                    el.style.display = type === 'retractable_pergko' ? '' : 'none';
                });
                document.querySelectorAll('.tilt-retractable-settings').forEach(el => {
                    el.style.display = type === 'tilt_retractable_pergko' ? '' : 'none';
                });
                document.querySelectorAll('.tento-settings').forEach(el => {
                    el.style.display = type === 'tento_pergko' ? '' : 'none';
                });
                document.querySelectorAll('.glass-roof-settings').forEach(el => {
                    el.style.display = type === 'glass_roof_pergko' ? '' : 'none';
                });

                setTimeout(() => {
                    buildGlassRoof();
                    refreshAllGuillotines();
                }, 150);
            }

            document.querySelectorAll('input[name="pergolaType"]').forEach(r => {
                r.addEventListener('change', function () {
                    if (this.checked) onPergolaTypeChange(this.value);
                });
            });

            const glassRoofInput = document.getElementById('glassRoofPosition');
            if (glassRoofInput) {
                glassRoofInput.addEventListener('input', function () {
                    const val = parseFloat(this.value);
                    sliderValues.glassRoofPosition = val;
                    const scene = window.__pergolaScene;
                    const roofGroup = scene && scene.getObjectByName("glassRoofGroup");
                    if (roofGroup && roofGroup.userData && roofGroup.userData.updatePosition) {
                        roofGroup.userData.updatePosition(val);
                    }
                });
            }

            document.addEventListener('sliderValuesChanged', (e) => {
                if (e.detail && e.detail.slider === 'glassRoofPosition') {
                    const scene = window.__pergolaScene;
                    const roofGroup = scene && scene.getObjectByName("glassRoofGroup");
                    if (roofGroup && roofGroup.userData && roofGroup.userData.updatePosition) {
                        roofGroup.userData.updatePosition(e.detail.value);
                    }
                    return;
                }
                buildGlassRoof();
                refreshAllGuillotines();
            });

            document.addEventListener('colorChanged', () => {
                buildGlassRoof();
                refreshAllGuillotines();
            });

            const initInterval = setInterval(() => {
                if (window.__pergolaScene) {
                    clearInterval(initInterval);
                    const initialType = (document.querySelector('input[name="pergolaType"]:checked') || {}).value || 'bio_pergko';
                    onPergolaTypeChange(initialType);
                }
            }, 100);
        })();
    